import { BdsSelectChips } from 'blip-ds/dist/blip-ds-react/components';
import React, { useCallback, useEffect, useRef } from 'react';
import { SelectChipsProps } from 'typings';

export const SelectChips: React.FC<SelectChipsProps> = ({
    id,
    options,
    label,
    placeholder,
    icon,
    chips,
    disabled = false,
    canAddNew = false,
    newPrefix,
    isRequired = false,
    errorMessage = '',
    handleChange,
}) => {
    const blipSelectChipsRef = useRef<any>(null);

    const handleChipsChange = useCallback(
        (event: CustomEvent<any>) => {
            const updatedChips: string[] = event.detail?.data ?? [];
            handleChange(updatedChips);
        },
        [handleChange],
    );

    useEffect(() => {
        const { current } = blipSelectChipsRef;
        if (current) {
            current.addEventListener('bdsChangeChips', handleChipsChange);
            return () => {
                current.removeEventListener('bdsChangeChips', handleChipsChange);
            };
        }
    }, [handleChipsChange]);

    return (
        <BdsSelectChips
            style={{ backgroundColor: 'white', borderRadius: '10px' }}
            options={options}
            id={id}
            ref={blipSelectChipsRef}
            label={isRequired ? `${label} *` : label}
            danger={errorMessage !== ''}
            error-message={errorMessage}
            icon={icon}
            chips={chips}
            placeholder={placeholder}
            disabled={disabled}
            can-add-new={canAddNew}
            new-prefix={newPrefix}
        ></BdsSelectChips>
    );
};
